import {Injectable} from '@angular/core';
import {SecureApi} from '../../../core/secure.api';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class DocumentsService {
    TRACKING              = 'tracking';
    GENERAL              = 'general';
    SELF_REPORT           = 'self_report';
    REPEATED_SR           = 'repeated_sr';
    COMPARE_ACTION        = 'compare_action';
    CLINIC_VALIDATION     = 'clinic_validation';
    PROPOSAL              = 'proposal';

    SUPERADMIN_DASHBOARD = [
        this.GENERAL,
        this.TRACKING,
        this.SELF_REPORT,
        this.CLINIC_VALIDATION,
        this.PROPOSAL,
        this.REPEATED_SR,
        this.COMPARE_ACTION,
    ];
    constructor(public secureApi: SecureApi) {
    }
    /**
     * @returns {Observable<any>}
     */
    getItems() {
        let url = 'patient/get-document';
        // return users from backend in json format
        return this.secureApi.get(url);
    }

    /**
     * @returns {Observable<any>}
     */
    download(documentId: number) {
        let url = 'patient/download-document/' + documentId;
        return this.secureApi.downloadFile(url);

    }
}
